import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import moment from "moment";
import { Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getCommonState, getVoucherState } from "../../redux/store/getState";
import { RequestAtc } from "../../redux/apiSlice/requestSlice";
import modifyId from "../../utils/modifyId";
import studentId from "../../utils/studentId";
import {
  filterPublicAtc,
  getVouchersPublic,
} from "../../redux/apiActions/voucherActions";
import useSearch from "../../hooks/useSearch";
import { clearFilterValues } from "../../redux/apiSlice/commonSlice";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const RequestUserTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const { vouchersPublic, loading } = useAppSelector(getVoucherState);
  const { filterFrom, filterTo, atc_id } = useAppSelector(getCommonState);
  const [data, setData] = useState<RequestAtc[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  useSearch(vouchersPublic, setData);

  useEffect(() => {
    if (filterFrom && filterTo && atc_id) {
      dispatch(filterPublicAtc({ from: filterFrom, to: filterTo, atc_id }));
    } else {
      dispatch(getVouchersPublic());
    }
  }, [filterFrom, filterTo, atc_id, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearFilterValues());
    };
  }, [dispatch]);

  const columns: ColumnsType<RequestAtc> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Request ID",
      dataIndex: "id",
      render: (id) => <>{modifyId(id)}</>,
    },
    {
      title: "Student ID",
      dataIndex: "user",
      render: (user) => <>{studentId(user)}</>,
    },
    {
      title: "Username",
      dataIndex: "user",
      render: (user) => <>{user.username}</>,
    },
    {
      title: "Email ID",
      dataIndex: "user",
      render: (user) => <>{user.email}</>,
    },
    {
      title: "Exam ID",
      dataIndex: "exam",
      render: (exam) => <>{modifyId(exam.id)}</>,
    },
    {
      title: "Exam Name",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
    {
      title: "Voucher Code",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
    {
      title: "Expiry Date",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
    {
      title: "Voucher Status",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
    {
      title: "Action",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
  ];

  return (
    <>
      <Table
        style={{ marginTop: 20, whiteSpace: "pre" }}
        loading={loading.getRequest}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        onChange={(p) =>
          setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
        }
        pagination={pagination}
        rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
      />
    </>
  );
};

export default RequestUserTable;
